// extracted by mini-css-extract-plugin
export var addressInfo = "printableShipTicket-module--addressInfo--dbe9e";
export var barcode = "printableShipTicket-module--barcode--ee417";
export var commentContainer = "printableShipTicket-module--commentContainer--8aabc";
export var fromToContainer = "printableShipTicket-module--from-to-container--f7944";
export var fromToItem = "printableShipTicket-module--from-to-item--630c1";
export var header = "printableShipTicket-module--header--0b119";
export var item = "printableShipTicket-module--item--b1849";
export var itemContainer = "printableShipTicket-module--item-container--f70b0";
export var itemInfoGrid = "printableShipTicket-module--item-info-grid--bf285";
export var itemsContainer = "printableShipTicket-module--items-container--02dca";
export var pagebreak = "printableShipTicket-module--pagebreak--d5429";
export var printContent = "printableShipTicket-module--print-content--43352";
export var tickBox = "printableShipTicket-module--tick-box--5a3f5";
export var tickboxContainer = "printableShipTicket-module--tickbox-container--dbd31";